import register from 'preact-custom-element'
import { AthosRecommendProvider } from '@/components/libs/athos/fetchers/recommend'
import { GridResults } from '@/components/libs/athos/components/GridResults'
import useCartGlobal from 'hooks/useCartGlobal'

/**
 * A SearchSpring recommendations grid, configured per block rather than from theme settings.
 *
 * Basecamp's equivalent block wraps Athos (`x-recs-recommend-grid`); the schema shape is kept
 * identical so swapping the engine later is a change of this element, not of the block.
 *
 * Replaces CartPopularProducts, which read its profile from GM_STATE.cart.emptyCollectionProfile.
 * Note GridResults still reads GM_STATE.cart.emptyCollectionId for its tracking section id, so two
 * grids with different profiles would report against one section — recorded in the spec.
 */
function RecommendationsGrid(props) {
  const { cartConfig } = useCartGlobal()
  const profile = props.dataProfile
  const title = props.dataTitle ?? ''
  const limit = props.dataLimit ?? '4'

  if (!profile) return null

  const productIds = (cartConfig.cart?.items ?? []).map((item) => item.product_id).join(',')

  return (
    <AthosRecommendProvider profile={profile} limit={limit} productId={productIds}>
      {/*
        No `title`: GridResults renders it as its own <p class="h4"> heading, and in this system
        headings are `text` blocks the merchant owns. Passing it produced two "Popular Products".
        `sectionName` is analytics only, so the title still travels with the beacon.
      */}
      <GridResults sectionId={profile} sectionName={title} title="" />
    </AthosRecommendProvider>
  )
}

register(RecommendationsGrid, 'recommendations-grid')
